<template>
	<div v-if="widthScreen < 1024 && !!info" class="position-relative">
		<!-- <div style="height: 6rem"></div> -->

		<div class="Fixed">
			<div class="header-fixed d-flex align-items-center gap-x-2">
				<span style="font-size: 3rem; font-weight: 600">{{ info.day }}</span>
				<div>
					<span class="Fixed__date">{{ curDate.format("dddd").toUpperCase() }}</span>
					<br />
					<small>• {{ info.data.length }} Eventos</small>
				</div>
				<div
					v-if="info.data.length > 0"
					:class="[!show ? 'active' : '']"
					@click="show = !show"
					class="card-arrow bg-primary"
				>
					<FeatherIcon icon="ChevronDownIcon" size="32" class="text-white cursor-pointer" />
				</div>
			</div>
			<div class="container-items" :class="[show ? 'active' : '']" v-if="info.data.length > 0">
				<hr />
				<div
					class="m-1 d-flex justify-content-between align-items-center gap-x-2 rounded-lg p-1 card-fixed"
					:style="{
						backgroundColor: event.color,
					}"
					v-for="(event, index) in info.data"
					:key="index"
					@click="$emit('selectDateByCalendar', event.date_id)"
				>
					<div class="text-light d-flex align-content-center">
						<div class="d-flex flex-column mr-1" style="gap: 8px;">
							<span class="font-size-lg font-weight-bold" style="padding: 0 !important;">{{ event.stage_name }}</span>
							<small>{{ event.tournament_name }}</small>
						</div>
					</div>
					<div v-if="event.classify" class="d-flex align-items-center" style="gap: 12px;">
						<div class="d-flex flex-column align-items-center" style="gap: 4px;">
							<v-icon 
								name="fa-award" 
								scale="1.7"  
								class="text-warning" style="background-color: var(--dark); border-radius: 50%; padding: 0.1rem; ">
							</v-icon>
							<span class="font-size-md font-weight-bold" style="padding: 0 !important; color: var(--white);">CLASIFICADO</span>
						</div>
						<div>
							<b-img
								rounded="circle"
								v-bind="mainProps"
								:src="event.avatar_image_thumb"
								v-if="event.avatar_image_thumb"
							/>
							<b-img rounded="" v-bind="mainProps" src="data:image/png;base64,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" v-else />
						</div>
					</div>
					<div v-else>
						<b-img
							rounded="circle"
							v-bind="mainProps"
							:src="event.avatar_image_thumb"
							v-if="event.avatar_image_thumb"
						/>
						<b-img rounded="" v-bind="mainProps" src="data:image/png;base64,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" v-else />
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment"

export default {
	props: {
		info: Object,
	},
	data: () => ({
		mainProps: { width: 50, height: 50 },
		show: false,
	}),
	computed: {
		widthScreen() {
			return this.$store.state.app.windowWidth
		},
		curDate() {
			if (!this.info) return {}
			return moment(this.info.date).locale("es")
		},
		dateCalendar() {
			return this.info ? this.info.date : ""
		},
	},
	watch: {
		dateCalendar() {
			if (this.info.data.length > 0 && this.info.date != moment(new Date()).format("YYYY-MM-DD")) {
				this.show = true
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.Fixed {
	position: fixed;
	width: 100%;
	bottom: 0;
	left: 0;
	height: auto;
	// padding: 2rem;
	background: var(--white);
	border-radius: 1rem 1rem 0 0;
	box-shadow: 0 0 1rem rgba($color: #000000, $alpha: 0.2);
	transition: all 0.5s ease;
	// max-height: 40vh;
	// overflow: auto;
	z-index: 100;
	.header-fixed {
		position: sticky;
		top: 0;
		background: #fff;
		padding: 2rem;
		.card-arrow {
			position: absolute;
			top: -18px;
			left: 50%;
			border-radius: 50%;
			height: 36px;
			width: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			transform: translateX(-50%);
			transition: 0.3s all ease-in-out;
		}
		.active {
			transform: rotate(180deg) translateX(50%);
		}
	}

	.card-fixed {
		margin-bottom: 0.5rem;
		&:last-child {
			margin-bottom: 0;
		}
	}
	.container-items {
		// max-height: 0;
		height: 0;
		overflow: hidden;
		transition: 0.3s all ease-in-out;
	}
	.active {
		overflow: auto;
		height: 50vh;
	}
}
</style>
